import { FC, HTMLAttributes, ReactNode } from 'react';

import { Flex, Typography } from 'antd';
import cn from 'classnames';

import styles from './PageTitle.module.scss';

interface IPageTitleProps extends HTMLAttributes<HTMLDivElement> {
	subtitle?: ReactNode;
	image?: ReactNode;
}

export const PageTitle: FC<IPageTitleProps> = ({ className, children, subtitle, image, ...props }) => {
	return (
		<Flex {...props} vertical gap={8} className={cn(className, styles.pageTitle)}>
			{!!image && <Flex>{image}</Flex>}
			<Typography.Title level={3} style={{ margin: 0 }}>
				{children}
			</Typography.Title>
			{subtitle && <Typography.Text type="secondary">{subtitle}</Typography.Text>}
		</Flex>
	);
};
